import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <MiniResourceCard slots="image,heading,text,link" repeat="3" theme="lightest" inRow="3" textColor="#424242" className="marketPlace inRow" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e15aaf54ac51e7bec753896afcd911c4/e72e6/Design_Buddy.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/e15aaf54ac51e7bec753896afcd911c4/de2c4/Design_Buddy.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/e15aaf54ac51e7bec753896afcd911c4/de2c4/Design_Buddy.png",
            "alt": "Design Buddy",
            "title": "Design Buddy",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "design-buddy"
    }}>{`Design Buddy`}</h2>
    <p>{`An AI-powered assistant to review your designs`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w236j7h7j"
      }}>{`https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w236j7h7j`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/256a731149ddf15a347b35f123919c42/e72e6/Audio_Stock.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/256a731149ddf15a347b35f123919c42/de2c4/Audio_Stock.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/256a731149ddf15a347b35f123919c42/de2c4/Audio_Stock.png",
            "alt": "AudioStock",
            "title": "AudioStock",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "audiostock"
    }}>{`AudioStock`}</h2>
    <p>{`Elevate your content with royalty-free music and SFX`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w072hm543"
      }}>{`https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=w072hm543`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/962ff91a4ccd76ebe23b2fd9ddeb84a6/e72e6/Simple_Booklet.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/add-ons/static/962ff91a4ccd76ebe23b2fd9ddeb84a6/de2c4/Simple_Booklet.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/add-ons/static/962ff91a4ccd76ebe23b2fd9ddeb84a6/de2c4/Simple_Booklet.png",
            "alt": "Simple Booklet",
            "title": "Simple Booklet",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "simple-booklet"
    }}>{`Simple Booklet`}</h2>
    <p>{`Present your documents as interactive flipbooks`}</p>
    <p><a parentName="p" {...{
        "href": "https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wji52hkm6"
      }}>{`https://adobesparkpost.app.link/TR9Mb7TXFLb?addOnId=wji52hkm6`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      